export default ({
    name : 'ProductBestSample'
    , props : {
        'changeRowsEng' : String
        , 'showType' : String 
        , 'showTypeEnum' : Array 
        , 'rows' : Number
        , 'column' : Number
    }
    , data () {
        return {
            productList : []
            , sampleProduct : [] 
        }
    }
    , created () {
        switch (this.getSkin()) {
            case 'basic':
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_cafe_prd_img1.jpg'
                    , 'prd_name' : '바닐라라떼'
                    , 'prd_name_add' : '깊고 진한 에스프레소, 고소한 우유와 향긋한 바닐라 향이 가득한 라떼'
                    , 'prd_discount_rate' : 5 
                    , 'prd_price' : 2850
                    , 'prd_origin_price' : 3000 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_cafe_prd_img2.jpg'
                    , 'prd_name' : '카라멜마끼아또'
                    , 'prd_name_add' : '깊고 진한 에스프레소, 고소한 우유와 향긋한 바닐라 향이 가득한 라떼'
                    , 'prd_discount_rate' : 10 
                    , 'prd_price' : 2700 
                    , 'prd_origin_price' : 3000 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_cafe_prd_img3.jpg'
                    , 'prd_name' : '핫초코라떼'
                    , 'prd_name_add' : '깊고 진한 에스프레소, 고소한 우유와 향긋한 바닐라 향이 가득한 라떼'
                    , 'prd_discount_rate' : 5 
                    , 'prd_price' : 2375 
                    , 'prd_origin_price' : 2500 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_cafe_prd_img4.jpg'
                    , 'prd_name' : '에스프레소'
                    , 'prd_name_add' : '깊고 진한 에스프레소, 고소한 우유와 향긋한 바닐라 향이 가득한 라떼'
                    , 'prd_discount_rate' : 5 
                    , 'prd_price' : 1900 
                    , 'prd_origin_price' : 2000 
                });
                break;
            case 'category':
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_shoppingmall_prd1.png'
                    , 'prd_name' : '아크릴 데코 CD 5pcs'
                    , 'prd_name_add' : '한번 맛보면 절대 멈출 수가 없어~ 마이소호 수제 마카롱 입점!'
                    , 'prd_discount_rate' : 5 
                    , 'prd_price' : 1425
                    , 'prd_origin_price' : 1500
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_shoppingmall_prd2.png'
                    , 'prd_name' : '알록달록 컴퍼스'
                    , 'prd_name_add' : '한번 맛보면 절대 멈출 수가 없어~ 마이소호 수제 마카롱 입점!'
                    , 'prd_discount_rate' : 5 
                    , 'prd_price' : 1900
                    , 'prd_origin_price' : 2000
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_shoppingmall_prd3.png'
                    , 'prd_name' : '더블크립 핑크 2pcs'
                    , 'prd_name_add' : '한번 맛보면 절대 멈출 수가 없어~ 마이소호 수제 마카롱 입점!'
                    , 'prd_discount_rate' : 0 
                    , 'prd_price' : 500
                    , 'prd_origin_price' : 500
                });
                break;
            case 'banner':
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_design_img1.jpg'
                    , 'prd_name' : '스포티 크롭탑 상하의 set'
                    , 'prd_name_add' : '라인 배색처리가 유니크한 분위기를 더해주고 소재특유의 신축성이 활동성을 높여주어요'
                    , 'prd_discount_rate' : 0 
                    , 'prd_price' : 45000 
                    , 'prd_origin_price' : 45000 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_design_img2.jpg'
                    , 'prd_name' : '웨이브 탱크 핑크 탑'
                    , 'prd_name_add' : '라인 배색처리가 유니크한 분위기를 더해주고 소재특유의 신축성이 활동성을 높여주어요'
                    , 'prd_discount_rate' : 0 
                    , 'prd_price' : 45000 
                    , 'prd_origin_price' : 45000 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_design_img3.jpg'
                    , 'prd_name' : '스포티 크롭탑 상하의 set'
                    , 'prd_name_add' : '라인 배색처리가 유니크한 분위기를 더해주고 소재특유의 신축성이 활동성을 높여주어요'
                    , 'prd_discount_rate' : 10
                    , 'prd_price' : 28800 
                    , 'prd_origin_price' : 31680 
                });
                this.sampleProduct.push({
                    'prd_img_first' : 'https://image.makeshop.co.kr/mysoho/assets/shop/pc/img/temp/pc_tmp_design_img4.jpg'
                    , 'prd_name' : '백 슬릿 슬리브리스 브라탑'
                    , 'prd_name_add' : '뒷태 반전 매력의 디자인과 기능성 소재로 후기 500개 돌파! 3시전 주문시 당일발송 상품입니다.'
                    , 'prd_discount_rate' : 5
                    , 'prd_price' : 23750 
                    , 'prd_origin_price' : 25000
                });
                break;
        }
        return {}
    }
    , mounted () {
    }
    , computed : {
        isShowType1 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(0)) return true;
            return false;
        }
        , isShowType2 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(1)) return true;
            return false;
        }
        , isShowType3 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(2)) return true;
            return false;
        }
        , isShowType4 () {
            if (this.getShowTypeValue() == this.getShowTypeEnumValue(3)) return true;
            return false;
        }
    }
    , methods : {
        getShowTypeValue () {
            return this.showType
        }
        , getShowTypeEnumValue (key) {
            return this.showTypeEnum[key]
        }
        , getProductList () {
            let productList = [];
            let productLimit = this.rows
            //let productLimit = this.rows * this.column
            let sampleIdx = 0
            for (let i=0; i < productLimit; i++) {
                productList[i] = this.sampleProduct[sampleIdx]
                if ((sampleIdx + 1) >= this.sampleProduct.length) {
                    sampleIdx = 0
                } else {
                    sampleIdx++
                }
            }
            return productList;
        }
        , showContent (index) {
            document.querySelectorAll('.bestItem-box div.cntInner')[index].style.display = 'block';
        }
        , hideContent (index) {
            document.querySelectorAll('.bestItem-box div.cntInner')[index].style.display = 'none';
        }
    }
    , updated () {
    }
})
